/* Publish by EComposer at 2025-08-01 17:11:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a6jyt3ztk0f"]=  window.__ectimmers["ecom-a6jyt3ztk0f"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a6jyt3ztk0f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6jyt3ztk0f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxehqf3tm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxehqf3tm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mf921dvr1tk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mf921dvr1tk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8tkvd71exn3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8tkvd71exn3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pipjtac3ot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pipjtac3ot', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4wl72u5mp7u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4wl72u5mp7u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-54k8nsilmnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-54k8nsilmnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-agr8fyaftu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-agr8fyaftu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdvykmaiynd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdvykmaiynd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cllgprr1cgg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cllgprr1cgg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0trs1qq1ko5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0trs1qq1ko5p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06b6eun6abip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06b6eun6abip', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qw6q2jqa21').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qw6q2jqa21', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77k9ngxzvpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77k9ngxzvpi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2fr8xkuxkpc"]=  window.__ectimmers["ecom-2fr8xkuxkpc"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-2fr8xkuxkpc"]["4jog5r46x"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2fr8xkuxkpc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2fr8xkuxkpc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sed7rb016q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sed7rb016q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mzstodjlki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mzstodjlki', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47pnizr4i5z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47pnizr4i5z', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7gd38p7z5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7gd38p7z5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0bshoekbxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0bshoekbxi', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3b6nb7aew03"]=  window.__ectimmers["ecom-3b6nb7aew03"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-3b6nb7aew03').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3b6nb7aew03', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8n1ewfnx0em').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8n1ewfnx0em', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8nbyb7voth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8nbyb7voth', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgtjmrgo8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgtjmrgo8n', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27auhhuf07pi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27auhhuf07pi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8dm21ddomtj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8dm21ddomtj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klw567ok1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klw567ok1a', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qmq9zoo7ivf"]=  window.__ectimmers["ecom-qmq9zoo7ivf"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var n=s.getAttribute("href")||"#",r=n.replace("{current-link}",location.href);s.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-qmq9zoo7ivf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmq9zoo7ivf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-aw0ovj3nkh"]=  window.__ectimmers["ecom-aw0ovj3nkh"] || {};
if(this.settings.layout==="slider"){let i=this.$el,t="bullets";if(this.settings.slider_pagination_style==="progress"&&(t="progressbar"),!i)return;let o=i.querySelector(".ecom-shopify__blog-container"),s=o&&o.dataset.optionSwiper;s=JSON.parse(s),s.pagination={el:i.querySelector(".ecom-swiper-pagination"),type:t,clickable:!0},s.navigation={nextEl:i.querySelector(".ecom-swiper-button-next"),prevEl:i.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(o,s)}if(this.settings.use_ajax&&this.isLive){const i=this.$el;if(!i)return;const t=i.querySelector(".ecom-shopify__blog-wrapper"),o=function(e){e.preventDefault();const a=this.dataset.get,n=this.closest(".ecom-sections[data-section-id]");if(!a||!n||!n.dataset.sectionId)return;const p=n.dataset.sectionId,_=`${a}&section_id=${p}`;c(_,n),t.scrollIntoView()};i.querySelectorAll(".ecom-pagination-item").forEach(e=>{e.addEventListener("click",o)});const c=function(e,a){const n=async function(p){return(await fetch(p,{method:"GET",cache:"no-cache",headers:{"Content-Type":"text/html"}})).text()};a.classList.add("ecom-doing-load-blog"),n(e).then(function(p){i.querySelectorAll(".ecom-shopify__blog--post").forEach(function(u){u.remove()});const d=document.createElement("div");d.innerHTML=p;const r=d.querySelector(".ecom-shopify__blog--posts");if(!r)return;const y=a.querySelector(".ecom-shopify__blog--posts"),$=a.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");for(;r.firstChild;)y.appendChild(r.firstChild);r.parentNode.removeChild(r);const h=d.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");h&&($.innerHTML=h.innerHTML,i.querySelectorAll(".ecom-pagination-item").forEach(v=>{v.addEventListener("click",o)}))}).finally(function(){a.classList.remove("ecom-doing-load-blog")})}}

                    });
                    
                        document.querySelectorAll('.ecom-aw0ovj3nkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw0ovj3nkh', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j0f5lzvymt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j0f5lzvymt', settings: {"layout":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}